import { DashboardLayout } from "components/Dashboard/DashboardLayout";
import { TwoChartTileSkeleton } from "components/Dashboard/OverviewSkeleton";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useTenant } from "hooks/useTenant";
import { Suspense } from "react";
import { getChemicalsBreadcrumb } from "util/breadcrumb";
import { ChemicalOverviewStateProvider } from "./ChemicalOverviewContext";
import { EncampFilingStatusTile } from "./Tiles/EncampFilingStatusTile";
import { EncampStatsTile } from "./Tiles/EncampStatsTile";
import { IssuesAndAnomaliesTile } from "./Tiles/IssuesAndAnomaliesTile";
import { MyFacilitiesTile } from "./Tiles/MyFacilitiesTile";
import { MyProgressTile } from "./Tiles/MyProgressTile";
import { MyReportStatusTile } from "./Tiles/MyReportStatusTile";
import { OutstandingReviewsTile } from "./Tiles/OutstandingReviewsTile";

export function Overview() {
  const { tenantId } = useTenant();
  useBreadcrumb([
    {
      label: "Chemicals",
      to: tenantId ? getChemicalsBreadcrumb(tenantId) : undefined,
    },
    {
      label: "Overview",
    },
  ]);

  return (
    <ChemicalOverviewStateProvider>
      <DashboardLayout>
        <Suspense
          fallback={
            <>
              <TwoChartTileSkeleton />
              <TwoChartTileSkeleton />
              <TwoChartTileSkeleton />
            </>
          }
        >
          <MyFacilitiesTile size={{ xs: 12, md: 6, xl: 5 }} />
          <OutstandingReviewsTile size={{ xs: 12, md: 6, xl: 4 }} />
          <EncampStatsTile size={{ xs: 12, xl: 3 }} />
          <MyProgressTile size={{ xs: 12, sm: 5, md: 4, lg: 3, xl: 2 }} />
          <MyReportStatusTile size={{ xs: 12, sm: 7, md: 8, lg: 5, xl: 5 }} />
          <EncampFilingStatusTile size={{ xs: 12, lg: 4, xl: 5 }} />
          <IssuesAndAnomaliesTile size={{ xs: 12 }} />
        </Suspense>
      </DashboardLayout>
    </ChemicalOverviewStateProvider>
  );
}
